<template>
  <div class>
    <div class="d-flex justify-content-center">
      <div class="col-12 bg-white py-4">
        <div class="row">
          <div class="col-12 banner-title">
            <span class="material-icons md-36" @click="goBack"
              >keyboard_arrow_left</span
            >
            <span class="title-text" @click="goBack">{{
              $t("message.store")
            }}</span>
          </div>
        </div>
        <form
          class="pt-2 pb-4 mt-2 d-flex flex-wrap justify-content-center"
          @submit.prevent="resetPassword"
        >
          <h3
            v-if="IsNewUser === 'true'"
            class="w-75 mb-5 mt-2 d-flex justify-content-center"
          >
            {{ $t("message.registerNewAccount") }}
          </h3>
          <h3 v-else class="w-75 mb-5 mt-2 d-flex justify-content-center">
            {{ $t("message.forgotPassword") }}
          </h3>
          <span
            class="form-group w-75 mt-4"
            v-if="recoveryLinkExpired"
            style="margin-botton: 20px"
            >{{ $t("message.passwordRecoveryLinkIsNoLongerValid") }}.</span
          >

          <div class="form-group w-75" v-if="UserDoc">
            <label for="First Name">{{ $t("message.firstName") }}</label>
            <br />
            <label
              id="FirstName"
              name="First Name"
              class="text-dark"
              v-if="UserDoc.FirstName"
            >
              <strong
                >{{ UserDoc.FirstName.substring(0, 1).toUpperCase()
                }}{{ UserDoc.FirstName.substring(1) }}</strong
              >
            </label>
          </div>
          <div class="form-group w-75" v-if="UserDoc">
            <label for="Last Name">{{ $t("message.lastName") }}</label>
            <br />
            <label
              id="LastName"
              name="Last Name"
              class="text-dark"
              v-if="UserDoc.LastName"
            >
              <strong
                >{{ UserDoc.LastName.substring(0, 1).toUpperCase()
                }}{{ UserDoc.LastName.substring(1) }}</strong
              >
            </label>
          </div>
          <div class="form-group w-75" v-if="UserDoc">
            <label for="email">{{ $t("message.email") }}</label>
            <br />
            <label
              id="email"
              class="text-dark"
              v-if="UserDoc.Email"
              name="email"
            >
              <strong
                >{{ UserDoc.Email.substring(0, 1).toUpperCase()
                }}{{ UserDoc.Email.substring(1) }}</strong
              >
            </label>
            <div class="invalid-feedback">
              {{ OOErrors.first("email") | inputNameLocale("email") }}
            </div>
          </div>
          <div class="form-group w-75" v-if="!registrationResponse && UserDoc">
            <label for="password">{{ $t("message.password") }}</label>
            <input
              id="passwordId"
              v-model="UserDoc.Password"
              type="password"
              name="password"
              v-validate="'required'"
              class="form-control"
              ref="password"
            />
            <div class="invalid-feedback">
              {{ OOErrors.first("password") | inputNameLocale("password") }}
            </div>
          </div>
          <div class="form-group w-75" v-if="!registrationResponse && UserDoc">
            <label for="Confirm Password">{{
              $t("message.confirmPassword")
            }}</label>
            <input
              id="ConfirmPasswordId"
              v-model="UserDoc.ConfirmPassword"
              type="password"
              name="confirmPassword"
              v-validate="'required|confirmed:password'"
              class="form-control"
            />
            <div class="invalid-feedback">
              {{
                OOErrors.first("confirmPassword")
                  | inputNameLocale("confirmPassword")
              }}
            </div>
          </div>

          <div
            class="w-75 mt-3"
            v-if="
              UserDoc &&
              (!registrationResponse ||
                (registrationResponse && registrationResponse.status != 200))
            "
          >
            <button
              :disabled="loading"
              :style="mobileStyles.btn"
              @click="resetPassword()"
              class="btn btn-lg btn-sign-in btn-block shadow btn-primary d-flex justify-content-center align-items-center"
            >
              {{ IsNewUser === "true" ? "Register" : "Reset" }}
              <span v-show="loading">
                <i class="spin ml-4" />
              </span>
            </button>
          </div>
          <div
            v-if="
              registrationResponse &&
              registrationResponse.status &&
              registrationResponse.status == 200
            "
            class="w-75 mt-4"
          >
            <div class="alert alert-success" role="alert">
              <strong>{{ registrationResponse.msg }}</strong>
            </div>
          </div>
          <div
            v-if="
              registrationResponse &&
              registrationResponse.status &&
              registrationResponse.status == 500
            "
            class="w-75 mt-4"
          >
            <div class="alert alert-danger" role="alert">
              <strong>{{ registrationResponse.msg }}</strong>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

import shared from "../../../../src/sharedscripts/user/register.js";

export default {
  components: {},
  props: {
    storeid: {
      type: String,
      default: "",
    },

    base64User: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      recoveryLinkExpired: false,
      email: "",
      password: "",
      loading: false,
      IsNewUser: "false",
      UserDoc: null,
      registrationResponse: null,
    };
  },
  computed: {
    ...mapGetters(["mobileStyles"]),
  },
  async mounted() {
    this.loadRecoveryPasswordForm(this.base64User);
  },
  methods: {
    ...shared.methods,
  },
};
</script>
